const COL_NUMBER = {
    name: 'Number',
    value: 'number',
    disabled: true,
    grow: true,
    minWidth: 100,
}

const COL_TYPE = {
    name: 'Type',
    value: 'type',
    align: 'center',
    activeDefault: true,
    minWidth: 80,
    padding: 'px-1',
}

const COL_NAME = {
    name: 'Name',
    value: 'name',
    disabled: true,
    grow: true,
    minWidth: 70,
}

const COL_VENDOR = {
    name: 'Vendor',
    value: 'vendor',
    grow: true,
    minWidth: 80,
}

const COL_PAYOUT = {
    name: 'Payout',
    value: 'payout',
    minWidth: 70,
}

const COL_STATUS = {
    name: 'Status',
    value: 'status',
    align: 'center',
    minWidth: 80,
}

const COL_ACTIONS = {
    name: 'Actions',
    value: 'actions',
    minWidth: 74,
    align: 'center',
    disabled: true,
    insertContent: true,
}

const COL_LIVE = {
    name: 'Live',
    value: 'live',
    align: 'center',
    activeDefault: false,
    insertContent: true,
    minWidth: 70,
}

const COL_HOURLY = {
    name: 'Hourly',
    value: 'hourly_revenue_cap',
    align: 'center',
    activeDefault: false,
    insertContent: true,
    minWidth: 70,
}

const COL_DAILY = {
    name: 'Daily',
    value: 'daily_revenue_cap',
    align: 'center',
    activeDefault: false,
    insertContent: true,
    minWidth: 70,
}

const COL_MONTHLY = {
    name: 'Monthly',
    value: 'monthly_revenue_cap',
    align: 'center',
    activeDefault: false,
    insertContent: true,
    minWidth: 70,
}

const COL_GLOBAL = {
    name: 'Global',
    value: 'global_revenue_cap',
    align: 'center',
    activeDefault: false,
    insertContent: true,
    minWidth: 70,
}

const CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE = [
    COL_NUMBER,
    COL_TYPE,
    COL_NAME,
    COL_VENDOR,
    COL_PAYOUT,
    COL_LIVE,
    COL_HOURLY,
    COL_DAILY,
    COL_MONTHLY,
    COL_GLOBAL,
    COL_STATUS,
]

const CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE_WITH_ACTIONS = [
    ...CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE,
    COL_ACTIONS,
]

const CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE_FOR_VENDOR = [
    COL_NUMBER,
    COL_TYPE,
    COL_NAME,
    COL_PAYOUT,
    COL_STATUS,
    COL_ACTIONS,
]

export {
    CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE,
    CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE_WITH_ACTIONS,
    CAMPAIGN_TRACKING_NUMBERS_HEADERS_TABLE_FOR_VENDOR,
}
